import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Portfolio from '../views/Portfolio.vue'
import contact from "@/views/Contact";

function lazyLoad(view){
  return() => import(`@/views/${view}.vue`)
}

const routes = [
  {
    path: '/',
    name: 'home',
    props: true,
    component: HomeView,
    meta: {
      title: "Woodtrends | Meubels op maat"
    }
  },
  {
    path: '/galerij',
    name: 'Galerij',
    props: true,
    component: lazyLoad('Portfolio'),
    meta: {
      title: "Galerij | Woodtrends"
    }
  },
  {
    path: '/contact',
    name: 'Contact',
    props: true,
    component: contact,
    meta: {
      title: "Contact | Woodtrends"
    }
  },
  {
    path: '/over-ons',
    name: 'About',
    props: true,
    component: lazyLoad('About'),
    meta: {
      title: "Over ons | Woodtrends"
    }
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})


router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
})

export default router
